export const EMAIL = {
  CUSTOMER: 'customermanagement@winefo.eu',
  GERMAN_CUSTOMER: 'B.Bleile@dlg.org',
};
